import { render, staticRenderFns } from "./singlePage.vue?vue&type=template&id=029e5030&"
import script from "./singlePage.vue?vue&type=script&lang=js&"
export * from "./singlePage.vue?vue&type=script&lang=js&"
import style0 from "./singlePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports